import * as React from "react";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import PersonIcon from "@mui/icons-material/Person";
import KeyIcon from "@mui/icons-material/Key";
import * as yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { loginUtente } from "../../const/CardDati";
import { notificationOpen } from "../../redux/reducers/notification-reducer";
import Notification from "../../components/UI/Notification/Notification";
import handlerError from "../../functions/handlerError";
import { Navigate } from "react-router-dom";
import Logo from '../../assests/logo.png'

const urlBase = process.env.REACT_APP_URL;
const versionNumber = process.env.REACT_APP_VERSION_NUMBER;

const validationSchema = yup.object({
  username: yup.string().required("Campo Obbligatorio"),
  password: yup.string().required("Campo Obbligatorio"),
});

const initialValues = {
  username: "",
  password: "",
};

const Login = () => {
  const state = useSelector((state) => state.userDate);
  const [changedRow, setchangedRow] = useState();
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true, // rinizializza il valore che gli viene passato con rowInfo
    onSubmit: (values) => {
      setchangedRow({
        username: values.username,
        password: values.password,
      });
    },
  });

  useEffect(() => {
    if (changedRow != null) {
      (async () => {
        let body = changedRow;

        const { action, method } = loginUtente;
        let url = urlBase + action;
        try {
          const response = await axios({
            method: method,
            url,
            data: body,
          });
          if (!response.data.ok) {
            dispatch(
              notificationOpen({
                message: response.data.message,
                status: response.data.ok,
                })
              );
          }
        } catch (error) {
          console.error(error);
          const notificationError = handlerError(error)
          dispatch(notificationOpen(notificationError))
        }
      })();
    }
  }, [changedRow]);

  return (
    Object.entries(state).length !== 0 ? <Navigate to="/dashboard" /> :
    <>
      <Container component="main" maxWidth="sm">
        <Card sx={{ marginTop: "15%" }}>
          <Box
            sx={{
              marginTop: 2,
              marginBottom: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box sx={{marginBottom:"20px"}}>
              <img src={Logo} alt="Logo" />
            </Box>
            <Typography variant="h4">
              CALL DETECTOR
            </Typography>
            <Typography variant="subtitle1">
              Esegui l'accesso
            </Typography>
            <Typography variant="subtitle2">
              {versionNumber}
            </Typography>
            <form onSubmit={formik.handleSubmit} style={{marginTop: 1, width: 300 + 'px'}}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <PersonIcon sx={{ color: "action.active", mr: 1, my: 0.5 }} />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="username"
                  label="Username"
                  name="username"
                  autoComplete="username"
                  autoFocus
                  variant="standard"
                  onChange={formik.handleChange("username")}
                  error={
                    formik.touched.username && Boolean(formik.errors.username)
                  }
                  helperText={formik.touched.username && formik.errors.username}
                />
              </Box>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <KeyIcon sx={{ color: "action.active", mr: 1, my: 0.5 }} />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  variant="standard"
                  onChange={formik.handleChange("password")}
                  error={
                    formik.touched.password && Boolean(formik.errors.password)
                  }
                  helperText={formik.touched.password && formik.errors.password}
                />
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Login
                </Button>
              </Box>
              <Grid container>
                <Grid item xs>
                  {/* <Link href="#" variant="body2">
                    Hai dimenticato la password?
                  </Link> */}
                </Grid>
              </Grid>
            </form>
          </Box>
        </Card>
      </Container>
      <Notification />
    </>
                
  );
};

export default Login;
